import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { isOriginInUse } from '../../util/search';
import {hasPermissionToViewData, isUserAuthorized} from "../../util/userHelpers";
import {parse} from "../../util/urlHelpers";
import { util as sdkUtil} from "../../util/sdkLoader";
import {
  getAthletesByParams
} from '../../util/api';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 12 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const RESULT_PAGE_SIZE = 24;

// ================ Action types ================ //
export const SEARCH_ATHLETES_REQUEST = 'app/OnlineTeachingJobsPage/SEARCH_ATHLETES_REQUEST';
export const SEARCH_ATHLETES_SUCCESS = 'app/OnlineTeachingJobsPage/SEARCH_ATHLETES_SUCCESS';
export const SEARCH_ATHLETES_ERROR = 'app/OnlineTeachingJobsPage/SEARCH_ATHLETES_ERROR';


// ================ Reducer ================ //

const initialState = {
  searchAthletesInProgress: false,
  searchAthletesError: null,
  athletes: [],
  searchParams: null,
  pagination: null
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case SEARCH_ATHLETES_REQUEST:
      return {
        ...state,
        searchParams: payload.searchParams,
        searchAthletesInProgress: true,
        athletes: [],
        searchAthletesInError: null,
      };
    case SEARCH_ATHLETES_SUCCESS:
      return {
        ...state,
        athletes: payload?.users,
        pagination: payload?.response?.data?.meta || null,
        searchAthletesInProgress: false,
      };
    case SEARCH_ATHLETES_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchAthletesInProgress: false, searchAthletesError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const searchAthletesRequest = searchParams => ({
  type: SEARCH_ATHLETES_REQUEST,
  payload: { searchParams },
});

export const searchAthletesSuccess = (response, users) => ({
  type: SEARCH_ATHLETES_SUCCESS,
  payload: {response, users},
});

export const searchAthletesError = e => ({
  type: SEARCH_ATHLETES_ERROR,
  error: true,
  payload: e,
})

// ================ Thunk ================ //

export const searchAthletes = searchParams => (dispatch, getState, sdk) => {
  dispatch(searchAthletesRequest(searchParams));

  const params = {
    page: searchParams.page,
    perPage: searchParams.perPage,
    pub_userType: 'athlete',
  }


  return getAthletesByParams(params)
    .then(res => {
      const users = !!res ? denormalisedResponseEntities(res) : null;
      dispatch(searchAthletesSuccess(res, users));
      return !!res?.data ? res?.data : res;
    })
    .catch(e => {
      dispatch(searchAthletesError(storableError(e)));
      throw e;
    });
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  // In private marketplace mode, this page won't fetch data if the user is unauthorized
  const state = getState();
  const currentUser = state.user?.currentUser;
  const isAuthorized = currentUser && isUserAuthorized(currentUser);
  const hasViewingRights = currentUser && hasPermissionToViewData(currentUser);
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const canFetchData =
    !isPrivateMarketplace || (isPrivateMarketplace && isAuthorized && hasViewingRights);
  if (!canFetchData) {
    return Promise.resolve();
  }

  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const { page = 1, address, origin, ...rest } = queryParams;
  const originMaybe = isOriginInUse(config) && origin ? { origin } : {};


  const parameters =  {
    include: ['effectivePermissionSet', 'profileImage', 'stripeAccount'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.square-xsmall',
      'variants.square-xsmall2x',
    ],
    'imageVariant.square-xsmall': sdkUtil.objectQueryString({
      w: 40,
      h: 40,
      fit: 'crop',
    }),
    'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
      w: 80,
      h: 80,
      fit: 'crop',
    }),
  };

  const searchAthletesCall = searchAthletes(
    {
      ...rest,
      ...originMaybe,
      page,
      perPage: RESULT_PAGE_SIZE,
      ...parameters
    },
    config
  );
  return dispatch(searchAthletesCall);
};

